import React from 'react';
import { useI18n } from 'react-simple-i18n';
import appstate from '../appstate';

function Izvlecki() {
	const pdfSvgIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke="currentColor"
			className="w-6 h-6 pt-1"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
			/>
		</svg>
	);

	const chevronRightIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke="currentColor"
			className="w-6 h-6"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.25 4.5l7.5 7.5-7.5 7.5"
			/>
		</svg>
	);

	const chevronLeftIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke="currentColor"
			className="w-6 h-6"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M15.75 19.5L8.25 12l7.5-7.5"
			/>
		</svg>
	);

	return (
		<div
			id={'izvlecki'}
			className={'mt-12 flex flex-row pb-8 relative'}
			style={{
				scrollBehavior: 'smooth',
				overflowX: 'scroll',
				overflowY: 'hidden',
			}}
		>
			<div
				className={
					'sticky left-0 top-0 bg-accent-light-100 pr-10 cursor-pointer'
				}
				onClick={() => {
					const izvlecki = document.getElementById('izvlecki');
					if (izvlecki) {
						izvlecki.scrollLeft = izvlecki.scrollLeft - 410;
					}
				}}
			>
				{chevronLeftIcon}
			</div>
			<div className={'min-w-fit mr-8'}>
				<a
					className={
						'hover:underline text-lg text-secondary-600 flex flex-row'
					}
					href={
						'https://www.gemini.com/documents/credit/Test_PDF.pdf'
					}
					target={'_blank'}
					rel="noreferrer"
				>
					{pdfSvgIcon} Testni Izvlecek.pdf
				</a>
			</div>
			<div className={'min-w-fit mr-8'}>
				<a
					className={
						'hover:underline text-lg text-secondary-600 flex flex-row'
					}
					href={
						'https://www.gemini.com/documents/credit/Test_PDF.pdf'
					}
					target={'_blank'}
					rel="noreferrer"
				>
					{pdfSvgIcon} Testni Izvlecek.pdf
				</a>
			</div>
			<div className={'min-w-fit mr-8'}>
				<a
					className={
						'hover:underline text-lg text-secondary-600 flex flex-row'
					}
					href={
						'https://www.gemini.com/documents/credit/Test_PDF.pdf'
					}
					target={'_blank'}
					rel="noreferrer"
				>
					{pdfSvgIcon} Testni Izvlecek.pdf
				</a>
			</div>
			<div className={'min-w-fit mr-8'}>
				<a
					className={
						'hover:underline text-lg text-secondary-600 flex flex-row'
					}
					href={
						'https://www.gemini.com/documents/credit/Test_PDF.pdf'
					}
					target={'_blank'}
					rel="noreferrer"
				>
					{pdfSvgIcon} Testni Izvlecek.pdf
				</a>
			</div>
			<div className={'min-w-fit mr-8'}>
				<a
					className={
						'hover:underline text-lg text-secondary-600 flex flex-row'
					}
					href={
						'https://www.gemini.com/documents/credit/Test_PDF.pdf'
					}
					target={'_blank'}
					rel="noreferrer"
				>
					{pdfSvgIcon} Testni Izvlecek.pdf
				</a>
			</div>
			<div className={'min-w-fit mr-8'}>
				<a
					className={
						'hover:underline text-lg text-secondary-600 flex flex-row'
					}
					href={
						'https://www.gemini.com/documents/credit/Test_PDF.pdf'
					}
					target={'_blank'}
					rel="noreferrer"
				>
					{pdfSvgIcon} Testni Izvlecek.pdf
				</a>
			</div>
			<div className={'min-w-fit mr-8'}>
				<a
					className={
						'hover:underline text-lg text-secondary-600 flex flex-row'
					}
					href={
						'https://www.gemini.com/documents/credit/Test_PDF.pdf'
					}
					target={'_blank'}
					rel="noreferrer"
				>
					{pdfSvgIcon} Testni Izvlecek.pdf
				</a>
			</div>
			<div className={'min-w-fit mr-8'}>
				<a
					className={
						'hover:underline text-lg text-secondary-600 flex flex-row'
					}
					href={
						'https://www.gemini.com/documents/credit/Test_PDF.pdf'
					}
					target={'_blank'}
					rel="noreferrer"
				>
					{pdfSvgIcon} Testni Izvlecek.pdf
				</a>
			</div>
			<div
				className={
					'sticky right-0 top-0 bg-accent-light-100 pl-10 cursor-pointer'
				}
				onClick={() => {
					const izvlecki = document.getElementById('izvlecki');
					if (izvlecki) {
						izvlecki.scrollLeft = izvlecki.scrollLeft + 410;
					}
				}}
			>
				{chevronRightIcon}
			</div>
		</div>
	);
}

export default function AboutView() {
	const { t } = useI18n();

	return (
		<div className={'max-w-8xl px-6 md:px-12 mx-auto'}>
			<div className={'w-full flex flex-col'}>
				<div className={'text-left'}>
					<span
						className={'text-4xl mb-5 text-primary-500 font-bold'}
						dangerouslySetInnerHTML={{
							__html: t('about.title0'),
						}}
					/>
					<span
						className={'text-3xl mb-5 text-primary-500'}
						dangerouslySetInnerHTML={{
							__html: t('about.title1') + '.',
						}}
					/>
				</div>
				<div
					className={'text-lg leading-8 leading-8 mb-12 mt-7'}
					dangerouslySetInnerHTML={{
						__html: t('about.body1'),
					}}
				/>
				<span
					className={'text-4xl mb-5 text-primary-500 font-bold'}
					dangerouslySetInnerHTML={{
						__html: t('about.title2'),
					}}
				/>
				<div>
					<iframe
						width="560"
						height="315"
						src="https://www.youtube.com/embed/GZAnbjEse-8"
						title="YouTube video player"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					></iframe>
				</div>
				<div
					className={
						'flex flex-col md:flex-row gap-6 py-10 justify-center items-start md:items-center'
					}
				>
					{appstate.partners().map((org, index) => {
						return (
							<div
								key={index}
								className={'flex justify-center items-center '}
							>
								<img src={org} className={'h-12 w-auto'} />
							</div>
						);
					})}
				</div>
				{/*<div className={'text-left mt-12'}>
				<span
					className={'text-4xl mb-5 text-primary-500 font-bold'}
					dangerouslySetInnerHTML={{
						__html: t('about.title3'),
					}}
				/>
			</div>
			<Izvlecki />*/}
			</div>
		</div>
	);
}
